<template>
    <section class="custom-dashboard" v-bind:class="{ 'mobile': this.$store.getters.isMobile }">
        <div class="container">
            <h1 class="page-title text-center text-base"><strong class="text-large-heading">Share</strong> <br><span class="text-large-sub-heading">Please enter all emails that you would like to share this dashboard with. Separate them with a comma</span></h1>

            <div class="text-center" v-if="activeInput == 'email'">
                <label class="text-light-alt text-weight-500 h2">Work Email Address</label>
                <input class="input" type="email" v-model="input">
            </div>

            <div class="text-center keyboard-wrapper" v-if="!this.$store.getters.isMobile">
                <keyboard
                  v-model="input"
                  @custom="custom"
                  :layouts="[
                    'qwertyuiop{delete:backspace}|asdfghjkl{clear:clear}|{shift:goto:1}zxcvbnm!?{shift:goto:1}|{?123:goto:2}/{space:space}@{.com:custom},',
                    'QWERTYUIOP{delete:backspace}|ASDFGHJKL{clear:clear}|{shift:goto:0}ZXCVBNM!?{shift:goto:0}|{?123:goto:2}/{space:space}@{.com:custom},',
                    '1234567890{delete:backspace}|-/:;()$&@{clear:clear}|{#+=:goto:3}.,?!\'|{abc:goto:0}/{space:space}@{.com:custom},',
                    '[]{{}}#%^+={delete:backspace}|_\\||~<>{clear:clear}|{?123:goto:2}.,?!\'|{abc:goto:0}/{space:space}@{.com:custom},',
                  ]"
                />
            </div>
        </div>
    </section>
</template>

<script>
    import router from '../router.js';
    import Keyboard from 'vue-keyboard';
    import EventBus from '../eventbus.js';

    export default {
        data : function() {
            return {
                input: '',
                activeInput: 'email'
            }
        },
        created() {

        },
        watch: {
            input( value ) {
                // this.$store.dispatch('updateUser', this.user);
                this.$store.commit('updateEmailList', value);
            }
        },
        computed: {
            user() {
                // let user = this.$store.getters.user;
                // return user;
            }
        },
        created() {
            //update the stacks whenever the addStack event is fired
            EventBus.$on( 'info.NextInput', (input) => {
                this.next(input);
            });

            EventBus.$on( 'shareEmail', (input) => {
                this.submit();
            });

            EventBus.$emit('shareView', true);
        },
        destroyed() {

            EventBus.$emit('shareView', false);
        },
        mounted() {
            EventBus.$emit('nav.updateAction', 'method');
            EventBus.$emit('shareView', true);
        },
        methods : {
            reverse() {

            },
            custom() {
                return this.input = this.input + '.com';
            },
            next( input ) {
                this.input = this.user.email;
                this.activeInput = input;
            },
            submit() {
                let data = sessionStorage.getItem('vuex');

                axios.post('/api/v1/share',{
                    params: {
                        emails: this.input,
                        data: JSON.stringify( data )
                    }
                })
                .then( ( response ) => {
                    console.log(  'what' );
                })
                .catch( function( error ) {
                  console.log( error );
                });
            }
        },
        components: {
            Keyboard,
        },
    }
</script>

<style lang="css" scoped>
    label {
        display: block;
        margin-bottom: 1.666em;
    }

    .custom-dashboard.mobile {
        height: calc(100vh - 70px);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/StepFour.vue